import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import AuctioneerExpertise from '../AuctioneerExpertise';
import { getAuctioneerUrl } from '../../utils/urls';
import {
    getAuctioneerName,
    getAuctioneerLocation,
    getDesignations,
} from '../../utils/auctioneer';
import {
    prefetchAuctioneer,
    prefetchAuctionsForUser
} from '../../gateways/auctionlook_api';

import './AuctioneerPreview.css';

const AuctioneerPreview = ({ auctioneer }) => {
    const auctioneerName = getAuctioneerName(auctioneer);
    const designations = getDesignations(auctioneer);
    const location = getAuctioneerLocation(auctioneer);
    const auctioneerUrl = getAuctioneerUrl(auctioneer.id);

    // Prefetch auctioneer profile and their auctions on hover
    var handleMouseEnter = useCallback(function() {
        prefetchAuctioneer(auctioneer.id);
        prefetchAuctionsForUser(auctioneer.id);
    }, [auctioneer.id]);

    return (
        <article className="al-auctioneer-card" onMouseEnter={handleMouseEnter}>
            {/* Card Body */}
            <div className="al-auctioneer-body">
                {/* Name */}
                <h2 className="al-auctioneer-name">
                    <Link
                        to={auctioneerUrl}
                        title={`Find out more about ${auctioneerName}`}
                    >
                        {auctioneerName}
                        {designations && (
                            <span className="al-auctioneer-designations">{designations}</span>
                        )}
                    </Link>
                </h2>

                {/* Company */}
                {auctioneer.Company && (
                    <div className="al-auctioneer-company">
                        {auctioneer.Company}
                    </div>
                )}

                {/* Location */}
                {location && (
                    <div className="al-auctioneer-location">
                        <MapPin size={14} />
                        <span>{location}</span>
                    </div>
                )}

                {/* Expertise */}
                <AuctioneerExpertise
                    auctioneer={auctioneer}
                    truncateList={true}
                    className="al-auctioneer-expertise"
                />
            </div>

            {/* Card Footer */}
            <footer className="al-auctioneer-footer">
                <Link
                    to={auctioneerUrl}
                    className="al-button al-button--outline"
                    title={`View ${auctioneerName}'s profile`}
                >
                    View Profile
                </Link>
            </footer>
        </article>
    );
};

AuctioneerPreview.propTypes = {
    auctioneer: PropTypes.object.isRequired
};

export default AuctioneerPreview;
